dealershipModule.factory("DealerPack", function() {

    //
    var dataSource = { none: "NONE", database: "DB", user: "USER"};

    // Constructor
    var DealerPack = function() {

        // all the properties in one place
        this.source = dataSource.none;  // not persistable
        this.productCode = "";
        this.productTypeCode = "";
        this.effectiveDate = null;  // a Date
        this.markups = [];
    };

    // This kind of stinks, because the term label Sets come from IM, and the dealer pack settings come from
    // bus svcs.  If there is a discrepancy between the label sets (specifies number of markup amounts, based
    // on product type), the term label sets are considered definitive. (see below)
    DealerPack.prototype.populateFromBusinessServices = function(source, termLabelSets) {
        this.source = dataSource.database;
        this.productCode = source.ProductCode || '';
        this.productTypeCode = source.ProductTypeCode || '';

        var date = source.EffectiveDate;
        if (angular.isString(date)) {
            var mmddyyyy = date.split('/');
            var yyyy = mmddyyyy[2], mm = mmddyyyy[0], dd = mmddyyyy[1];
            date = new Date(yyyy, mm - 1, dd);
        }

        this.effectiveDate = date;
        // convert server side array of markups into dictionary for looking up amounts by key.
        var markupsDictionary = _.object(source.Markups.map(function(markup) { return [ markup.Key, markup.Amount]; }));

        // reconstruct as client side markups array, ordered as in the term label set.
        // The term label sets wins if there are discrepancies: Values with unrecognized key are discarded. Missing keys default to 0 value.
        var termLabelSet = privateLookupTermLabelSet(this.productTypeCode, termLabelSets);
        this.markups = termLabelSet.terms.map(function(term) {
            return { key: term.key, amount: markupsDictionary[term.key] || 0.00 };
        });
        return this;  // convenient for mapping
    };

    DealerPack.prototype.convertForBusinessServices = function() {
        var result = {
            ProductCode: this.productCode || '',
            ProductTypeCode: this.productTypeCode || '',
            EffectiveDate: angular.isDate(this.effectiveDate) ? this.effectiveDate.mmddyyyy() : this.effectiveDate,
            Markups: this.markups.map(function(markup) { return { Key: markup.key, Amount: markup.amount || 0.00 }})
        };
        return result;
    };

    DealerPack.prototype.toDisplayString = function() {
        if (!this.markups || this.markups.length == 0)
            return "$0";

        if (this.markups.length == 1)
            return "$" + this.markups[0].amount;

        // this will have to do for now, if there are multiple values.
        return "Multiple: $" + (this.markups.map(function(markup) { return markup.amount; })).join(", $");

    };

    DealerPack.prototype.setMarkupKeys = function(termLabelSets) {
        var termLabelSet = privateLookupTermLabelSet(this.productTypeCode, termLabelSets);
        this.markups = termLabelSet.terms.map(function(term) { return { key: term.key, amount: null}; });
    };

    // Returns true iff this dealer pack was obtained from database
    DealerPack.prototype.isFromDB = function() {
        return this.source === dataSource.database;
    };

    // Returns true iff this dealer pack can be persisted, meaning it was created by user or came from the db
    DealerPack.prototype.isPersistable = function() {
        return this.source != dataSource.none;
    };

    DealerPack.prototype.ensurePersistable = function() {
        if (this.isPersistable())
            return;
        this.source = dataSource.user;
    };

    function privateLookupTermLabelSet(productTypeCode, termLabelSets) {
        // Called "term label set, because the labels are, in general for a set of terms.  Most product
        // types have only one item in the set, typically when when term is irrelevant.
        var foundTermLabelSet = _.find(termLabelSets, function(termLabelSet) {
            return termLabelSet.productType === productTypeCode || termLabelSet.productType === "*";
        });
        return foundTermLabelSet;
    }

    // Expose "Static" function: Gets info that determines how many "amount" boxes to display, and labels for each, based on product type.
    DealerPack.lookupTermLabelSet = privateLookupTermLabelSet;

    return DealerPack;
});